import React, { useState, useEffect } from 'react';
import { shouldShowAppBanner, detectMobileOS, generateAppLink } from '../../utils/deepLinkHandler';

interface AppBannerProps {
  currentPath?: string;
}

const AppBanner: React.FC<AppBannerProps> = ({ currentPath = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [os, setOs] = useState<'ios' | 'android' | 'other'>('other');

  useEffect(() => {
    const shouldShow = shouldShowAppBanner();
    const detectedOs = detectMobileOS();

    setIsVisible(shouldShow);
    setOs(detectedOs);
  }, []);

  const handleDownloadClick = () => {
    const appLinks = generateAppLink(currentPath);

    if (os === 'ios') {
      window.open(appLinks.ios, '_blank');
    } else if (os === 'android') {
      window.open(appLinks.android, '_blank');
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    // Store preference to not show banner for this session
    sessionStorage.setItem('appBannerDismissed', 'true');
  };

  useEffect(() => {
    const dismissed = sessionStorage.getItem('appBannerDismissed');
    if (dismissed) {
      setIsVisible(false);
    }
  }, []);

  if (!isVisible || os === 'other') {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#007AFF',
        color: 'white',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1000,
        fontSize: '14px',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
      <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            backgroundColor: 'white',
            borderRadius: '8px',
            marginRight: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px'
          }}>
          📱
        </div>
        <div>
          <div style={{ fontWeight: 'bold' }}>Get the Niyyah App</div>
          <div style={{ fontSize: '12px', opacity: 0.9 }}>Better experience in our native app</div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button
          onClick={handleDownloadClick}
          style={{
            backgroundColor: 'white',
            color: '#007AFF',
            border: 'none',
            borderRadius: '20px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}>
          {os === 'ios' ? 'App Store' : 'Play Store'}
        </button>

        <button
          onClick={handleClose}
          style={{
            backgroundColor: 'transparent',
            color: 'white',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            padding: '0',
            width: '24px',
            height: '24px'
          }}>
          ×
        </button>
      </div>
    </div>
  );
};

export default AppBanner;
